import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ArrowRight } from 'phosphor-react';
import { Link } from 'react-router-dom';
import { Bezel, Button, Input, Eyebrow } from '_ui';

export function ForgotPassword() {
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');
    const { register, handleSubmit, formState: { errors } } = useForm();

    async function onSubmit({ email }) {
        setLoading(true);
        setError('');
        try {
            const res = await fetch('/api/auth/forget_password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
            const data = await res.json();
            if (data.status === 'Success') {
                setSent(true);
            } else {
                setError(data.message?.description || data.message || 'Có lỗi xảy ra');
            }
        } catch {
            setError('Không thể kết nối máy chủ');
        }
        setLoading(false);
    }

    return (
        <div className="flex min-h-[100dvh] items-center justify-center px-6 py-12">
            <div className="w-full max-w-md">
                <Bezel className="px-8 py-10">
                    <Eyebrow className="mb-5">Quên mật khẩu</Eyebrow>
                    <h2 className="font-serif text-3xl text-espresso">Khôi phục mật khẩu</h2>
                    <p className="mt-2 text-sm text-espresso-soft/80">
                        Nhập email để nhận liên kết đặt lại mật khẩu.
                    </p>

                    {sent ? (
                        <div className="mt-8 space-y-4">
                            <p className="text-sm text-green-700">
                                Nếu email tồn tại trong hệ thống, hướng dẫn khôi phục đã được gửi. Kiểm tra hộp thư.
                            </p>
                            <Link to="/login" className="text-sm text-brass-deep hover:underline">
                                ← Quay lại đăng nhập
                            </Link>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit(onSubmit)} className="mt-8 space-y-5">
                            <Input
                                label="Email"
                                type="email"
                                placeholder="ban@sunnynail.io.vn"
                                autoComplete="email"
                                error={errors.email && 'Vui lòng nhập email'}
                                {...register('email', { required: true })}
                            />
                            {error && <p className="text-sm text-red-600">{error}</p>}
                            <Button type="submit" icon={ArrowRight} loading={loading} className="w-full justify-between" size="lg">
                                {loading ? 'Đang gửi…' : 'Gửi liên kết khôi phục'}
                            </Button>
                            <Link to="/login" className="block text-center text-sm text-espresso-soft/70 hover:underline">
                                ← Quay lại đăng nhập
                            </Link>
                        </form>
                    )}
                </Bezel>
            </div>
        </div>
    );
}
